import { extensions } from '../extensions/Extensions.mjs';
import { FilterPipe } from './FilterPipe.mjs';
import { FilterSystem } from './FilterSystem.mjs';

"use strict";
extensions.add(FilterSystem);
extensions.add(FilterPipe);
//# sourceMappingURL=init.mjs.map
